import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHTML',
})
export class SafeHTMLPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any , type:string = 'HTML'): unknown {
    if(type=== 'url')
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
